












import { Button, Input, message } from 'ant-design-vue'
import { Component, Vue } from 'vue-property-decorator'
import { invoke } from 'wecom-sidebar-jssdk'

@Component({
  name: 'Actions',
  components: {
    'a-button': Button,
    'a-input': Input,
    'a-textarea': Input.TextArea
  }
})
export default class Actions extends Vue {
  msg = '';

  async sendMsg () {
    if (!this.msg) alert('消息不能为空')

    try {
      await invoke('sendChatMessage', {
        msgtype: 'text',
        enterChat: true,
        text: {
          content: this.msg
        }
      })
    } catch (e) {
      message.error(e.message)
    }
  }
}
